<template>
    <div class="container page">
        <div class="header">
            <van-nav-bar :title="$t('my.兑换记录')" class="nav-bar">
                <template #left>
                    <van-icon name="arrow-left" color="#fff" @click="back()" />
                </template>
            </van-nav-bar>
        </div>
        <div class="content ">
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :pulling-text="$t('refresh.pulling')"
                :loosing-text="$t('refresh.loosing')" :loading-text="$t('refresh.loading')">

                <!-- <van-list
                      v-model="loading"
                      :finished="finished"
                      :immediate-check="false"
                      :finished-text="$t('video.no_more')"
                      @load="onLoad"
                  > -->
                <div class="shop_list">

                    <div v-for="(items, index) in shopList" :key="index" class="shop_list_item">
                        <van-image fit="contain" class="shop_list_item_img" :src="items.product_img" />
                        <!-- <div class="shop_list_point" style="font-size: 12px;">
                            <span style="font-size: 11px;color: #333;">{{ $t('my.数量') }}</span>:<span>{{ items.num
                                }}</span>

                        </div> -->
                        <div style="display: flex;flex-direction: column;">
                            <div class="shop_list_item_txt">{{ items.product_name }}</div>
                            <div style="flex: 1;"></div>
                            <div class="shop_list_point">
                            {{ $t('my.积分') }} : <span>{{ items.point }}</span>

                        </div>
                        </div>
                        
                        <!-- <div class="shop_list_item_btn" :class="(items.num == 0) ? 'hui' : ''"
                            @click="exchange(items, index)">
                            {{ $t('my.兑换') }}
                        </div> -->
                    </div>
                </div>

                <!-- </van-list> -->
            </van-pull-refresh>
        </div>
    </div>

</template>

<script>
// import { Dialog } from 'vant';
export default {
    data() {
        return {
            isLoading: false,
            shopList: [
            ],
            loading: false,
            finished: false,
            page: 1,
            userInfo: {}
        };
    },
    methods: {
        back() {
            return window.history.back();
        },
        getUserInfo() {
            this.$http({
                method: 'get',
                url: 'user_info'
            }).then(res => {
                if (res.code === 200) {
                    this.userInfo = res.data;
                } else if (res.code === 401) {
                    this.$toast(res.msg);
                }
            })
        },
        getList() {
            this.$http({
                method: 'get',
                url: 'exchangelog',
                data: {
                    page: this.page,
                    limit: 1000
                }
            }).then(res => {
                console.log(res.data)
                this.shopList = res.data.data
                // this.page++;
            })
        },
        onLoad() {
            // this.getList();
            // let timer = setTimeout(() => {
            //   if (this.refreshing) {
            //     this.shopList = [];
            //     this.refreshing = false;
            //   }
            //   this.loading = false;
            //   if (this.shopList.length === this.count) {
            //     this.finished = true;
            //   }
            //   this.finished && clearTimeout(timer);//清除计时器
            // }, 500);
        },
        onRefresh() {
            setTimeout(() => {
                this.$toast(this.$t("reservation.refresh"));
                this.isLoading = false;
                this.getList();
            }, 500);
        },
    },
    created() {
        this.getUserInfo()
        this.getList();
    }
};
</script>
<style lang='less'>
.van-dialog .van-button__text {

    font-size: 14px !important;
}
</style>

<style lang='less' scoped>
@import "../../assets/css/base.css";

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
    color: #000000;
    font-size: 35px;
}

::v-deep .van-loading__text {
    color: #000000;
    font-size: 35px;
}

.container .content {
    height: calc(100% - 20px);
    overflow: auto;
}

.shop_list_point {
    // margin: 10px;
    margin-top: 10px;
    text-align: left;
}

.shop_list_point span {
    margin: 10px;
    color: #a082f0;
}

.shop_list {
    // display: flex;
    // flex-wrap: wrap;
    padding: 20px 10px;
    box-sizing: border-box;
}

.shop_list_item {
    width: calc(100% - 40px);
    // width: 100%;
    margin: 20px;
    text-align: center;
    background: #fff;
    border-radius: 20px;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    // justify-content: space-around;
    // align-items: center;
    
}

.shop_list_item_img {
    width: 160px;
    height: 160px;
    border-radius: 20px;
    margin-right: 20px;
}

.shop_list_item_txt {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    // padding: 20px;
    // margin-top: 20px;
    text-align: left;
}

.shop_list_item_btn {
    background: #f48630;
    border-radius: 20px;
    padding: 20px;
    color: #fff;
    display: inline-block;
    width: 80%;
    margin-top: 20px;
}

.hui {
    background: gray;
}
</style>